import { useEffect, useMemo, useState } from 'react';

interface TypingTextProps {
  text: string;
  speedMs?: number;
  className?: string;
  replayKey?: number;
}

const TypingText = ({ text, speedMs = 40, className, replayKey = 0 }: TypingTextProps) => {
  const [index, setIndex] = useState(0);

  const safeText = useMemo(() => text || '', [text]);

  useEffect(() => {
    setIndex(safeText.length > 0 ? 1 : 0);
  }, [safeText, replayKey]);

  useEffect(() => {
    if (index >= safeText.length) return;
    const timer = window.setTimeout(() => setIndex((prev) => prev + 1), speedMs);
    return () => window.clearTimeout(timer);
  }, [index, safeText, speedMs]);

  return (
    <span className={className}>
      {safeText.slice(0, index)}
      {index < safeText.length ? <span className="opacity-70">|</span> : null}
    </span>
  );
};

export default TypingText;
